export default __webpack_public_path__ + "static/media/goldImg.5e81b53d.svg";